import { z } from 'zod';
import { PartnerMaterialSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * List Partner Materials
 * GET /api/v2/partner/materials
 */ export const ListPartnerMaterialsResponseSchema = z.object({
    data: z.array(PartnerMaterialSchema)
});

//# sourceMappingURL=list-partner-materials.schema.js.map